<template>
  <div class="club-setting-page">
    <div class="club-header-row">
      <div class="club-field">
        <label>Golf Club</label>
        <select v-model="selectedClub" class="club-select" @change="loadData">
          <option value="PIGC">PERFECT GOLF COURSE</option>
          <option value="BSD">BSD GOLF CLUB</option>
        </select>
      </div>
    </div>

    <div class="club-content">
      <aside class="club-side-panel">
        <div
          v-for="item in sideList"
          :key="item.value"
          class="side-item"
          :class="{ selected: selectedDate === item.value }"
          @click="selectDate(item.value)"
        >
          <span class="side-marker">▶</span>
          <span>{{ item.label }}</span>
        </div>
      </aside>

      <section class="club-detail-panel">
        <div class="detail-grid">
          <div class="field-row">
            <label class="field-label">Effective Date*</label>
            <div class="field-control">
              <input type="text" v-model="formData.effectiveDate" />
            </div>

            <label class="field-label right-label">Status</label>
            <div class="field-control status-box">
              <input type="text" v-model="formData.status" />
            </div>
          </div>

          <div class="field-row compact">
            <label class="field-label">Booking Days Restriction*</label>
            <div class="field-control small">
              <input type="text" v-model="formData.bookingDaysRestriction" />
            </div>
            <span class="suffix">days</span>

            <label class="field-label right-label">Number Of Course</label>
            <div class="field-control small">
              <input type="text" v-model="formData.numberOfCourse" />
            </div>
          </div>

          <div class="tab-row">
            <button
              v-for="tab in tabs"
              :key="tab.key"
              type="button"
              class="tab-btn"
              :class="{ active: activeTab === tab.key }"
              @click="setActiveTab(tab.key)"
            >
              {{ tab.label }}
            </button>
          </div>

          <div class="setting-grid">
            <div class="setting-row">
              <div class="wide-label">Tee Time Interval*</div>
              <div class="mini">
                <input type="text" v-model="formData.teeTimeInterval" />
              </div>
              <div class="unit">Minutes</div>

              <div class="check-box-group">
                <label class="check-inline">
                  <input type="checkbox" v-model="formData.secondNineBlocking" />
                  <span>2nd Nine Holes Blocking</span>
                </label>
                <label class="check-inline">
                  <input type="checkbox" v-model="formData.nightCourse" />
                  <span>Night Course</span>
                </label>
              </div>
            </div>

            <div class="setting-row">
              <div class="wide-label">Start Time For Morning Course</div>
              <div class="mini time-box"><input type="text" v-model="formData.morningStart" /></div>
              <span class="dash">-</span>
              <div class="mini time-box"><input type="text" v-model="formData.morningEnd" /></div>
              <div class="text-label">Flights/Course</div>
              <div class="mini small"><input type="text" v-model="formData.morningFlights" /></div>
              <div class="text-label">Max Players</div>
              <div class="mini small"><input type="text" v-model="formData.morningMaxPlayers" /></div>
              <div class="text-label">/ Tee Off</div>
            </div>

            <div class="setting-row">
              <div class="wide-label">Start Time For Afternoon Course</div>
              <div class="mini time-box"><input type="text" v-model="formData.afternoonStart" /></div>
              <span class="dash">-</span>
              <div class="mini time-box"><input type="text" v-model="formData.afternoonEnd" /></div>
              <div class="text-label">Flights/Course</div>
              <div class="mini small"><input type="text" v-model="formData.afternoonFlights" /></div>
              <div class="text-label">Max Players</div>
              <div class="mini small"><input type="text" v-model="formData.afternoonMaxPlayers" /></div>
              <div class="text-label">/ Tee Off</div>
            </div>

            <div class="booking-rows">
              <div class="booking-row" v-for="(item, idx) in bookingTimes" :key="idx">
                <div class="wide-label">{{ item.label }}</div>
                <div class="mini time-box"><input type="text" v-model="item.from" /></div>
                <span class="dash">-</span>
                <div class="mini time-box"><input type="text" v-model="item.to" /></div>
                <div class="text-label">Flights/Course</div>
                <div class="mini small"><input type="text" v-model="item.flights" /></div>
              </div>
            </div>

            <div class="bottom-row">
              <label class="check-inline big-check">
                <input type="checkbox" v-model="formData.dayOff" />
                <span>Day Off</span>
              </label>

              <select class="mini-select" v-model="formData.dayOffType">
                <option value="None">None</option>
                <option value="Tuesday">Tuesday</option>
                <option value="Wednesday">Wednesday</option>
              </select>
            </div>

            <div class="meta-row">
              <div class="meta-box">
                <label>Updated By</label>
                <div class="meta-value">
                  <input type="text" v-model="formData.updatedBy" />
                </div>
              </div>

              <div class="meta-box">
                <label>Created By</label>
                <div class="meta-value">
                  <input type="text" v-model="formData.createdBy" />
                </div>
              </div>
            </div>

            <div class="action-row">
              <button class="btn btn-default">Edit</button>
              <button class="btn btn-default">Delete</button>
              <button class="btn btn-default">Re-Drat</button>
              <button class="btn btn-default">Activate</button>
              <button class="btn btn-primary">Copy</button>
              <button class="btn btn-default">Save</button>
              <button class="btn btn-default">Cancel</button>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedClub: 'PIGC',
      selectedDate: '2020-10-01',
      activeTab: 'weekday',
      tabs: [
        { key: 'weekday', label: 'Weekday Setting' },
        { key: 'saturday', label: 'Saturday Setting' },
        { key: 'sunday', label: 'Sunday Setting' },
        { key: 'holiday', label: 'Holiday Setting' }
      ],
      sideList: [
        { label: '1-Oct-2020', value: '2020-10-01' },
        { label: '1-Oct-2021', value: '2021-10-01' }
      ],
      formData: {
        effectiveDate: '1-Oct-2020',
        status: 'Activated',
        bookingDaysRestriction: '30',
        numberOfCourse: '2',
        teeTimeInterval: '8',
        secondNineBlocking: false,
        nightCourse: false,
        morningStart: '05:30',
        morningEnd: '10:42',
        morningFlights: '40',
        morningMaxPlayers: '8',
        afternoonStart: '10:50',
        afternoonEnd: '16:58',
        afternoonFlights: '47',
        afternoonMaxPlayers: '8',
        dayOff: false,
        dayOffType: 'None',
        updatedBy: '1-Oct-2020',
        createdBy: '1-Oct-2020'
      },
      bookingTimes: [
        { label: 'Captain Booking Time (1)', from: '', to: '', flights: '' },
        { label: 'Captain Booking Time (2)', from: '', to: '', flights: '' },
        { label: 'Captain Booking Time (3)', from: '', to: '', flights: '' },
        { label: 'Captain Booking Time (4)', from: '', to: '', flights: '' }
      ]
    }
  },
  methods: {
    setActiveTab(tabKey) {
      this.activeTab = tabKey
    },
    selectDate(dateValue) {
      this.selectedDate = dateValue
      this.formData.effectiveDate = this.sideList.find(item => item.value === dateValue).label || dateValue
    },
    backToList() {
      this.$emit('back-to-list')

      if (this.$router) {
        this.$router.go(-1)
      }
    },
    loadData() {
      // nanti isi dari API
    }
  }
}
</script>

<style scoped>
.club-setting-page {
  background: #f1f5fb;
  min-height: 100%;
  padding: 10px 12px 20px;
  color: #2c4059;
  font-family: Arial, Helvetica, sans-serif;
}

.club-header-row {
  background: rgba(255,255,255,0.35);
  border: 1px solid #bfd0ea;
  border-bottom: none;
  padding: 12px 14px;
}

.club-field {
  display: flex;
  align-items: center;
  gap: 12px;
}

.club-field label {
  font-size: 14px;
  font-weight: 700;
  color: #2d405a;
  min-width: 88px;
}

.club-select {
  width: 300px;
  height: 32px;
  border: 1px solid #b8c5d9;
  background: #fff;
  border-radius: 3px;
  color: #2d405a;
  padding: 0 10px;
  font-size: 12px;
}

.club-content {
  display: grid;
  grid-template-columns: 260px 1fr;
  border: 1px solid #bfd0ea;
  background: rgba(255,255,255,0.12);
  min-height: 650px;
}

.club-side-panel {
  background: rgba(255,255,255,0.08);
  border-right: 1px solid #bfd0ea;
}

.side-item {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 42px;
  padding: 0 12px;
  border-bottom: 1px solid #d7e3f4;
  color: #2d405a;
  background: rgba(255,255,255,0.04);
  font-size: 12px;
  cursor: pointer;
}

.side-item.selected {
  background: #f7d672;
  font-weight: 700;
}

.side-marker {
  font-size: 11px;
  display: inline-block;
  width: 10px;
}

.club-detail-panel {
  background: rgba(255,255,255,0.08);
  padding: 12px 16px 0;
}

.detail-grid {
  border: 1px solid #bfd0ea;
  background: rgba(255,255,255,0.12);
  padding: 12px 14px 10px;
}

.field-row {
  display: grid;
  grid-template-columns: 220px minmax(300px, 1fr) 120px minmax(150px, 1fr);
  align-items: center;
  gap: 14px 18px;
  margin-bottom: 18px;
}

.field-row.compact {
  display: grid;
  grid-template-columns: 220px 110px 40px 150px 110px;
  align-items: center;
  gap: 10px 12px;
  margin-bottom: 18px;
}

.field-label {
  display: block;
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: #2d405a;
  line-height: 1.3;
}

.right-label {
  justify-self: start;
  margin-left: 8px;
}

.field-control {
  width: 100%;
}

.field-control.small {
  width: 100%;
}

.field-control input,
.mini input,
.mini-select,
.meta-value input,
.time-box input {
  width: 100%;
  height: 36px;
  border: 1px solid #bfd0ea;
  background: #fff;
  border-radius: 4px;
  color: #2d405a;
  padding: 0 10px;
  box-sizing: border-box;
}

.status-box input {
  background: #edf1f8;
}

.suffix {
  display: inline-block;
  font-size: 14px;
  color: #2d405a;
}

.tab-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0;
  margin: 8px 0 12px;
}

.tab-btn {
  border: 1px solid #bfd0ea;
  border-bottom: none;
  background: #e8edf7;
  color: #2d405a;
  font-size: 12px;
  font-weight: 700;
  padding: 9px 14px;
  text-transform: uppercase;
  cursor: pointer;
  line-height: 1;
}

.tab-btn + .tab-btn {
  margin-left: 2px;
}

.tab-btn.active {
  background: #edf5ff;
}

.setting-grid {
  border: 1px solid #bfd0ea;
  background: rgba(255,255,255,0.2);
  padding: 12px 10px;
  font-size: 12px;
}

.setting-row,
.booking-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  min-height: 42px;
  margin-bottom: 12px;
}

.wide-label {
  min-width: 220px;
  font-weight: 700;
  color: #2d405a;
}

.mini {
  width: 76px;
}

.time-box {
  width: 110px;
}

.small {
  width: 60px;
}

.dash {
  color: #2d405a;
  font-size: 13px;
  padding: 0 2px;
}

.text-label {
  font-size: 12px;
  color: #2d405a;
  white-space: nowrap;
}

.check-box-group {
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
  margin-left: auto;
}

.check-inline {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #2d405a;
  font-size: 12px;
}

.check-inline input {
  width: 14px;
  height: 14px;
}

.bottom-row {
  display: flex;
  align-items: center;
  gap: 16px;
  margin: 16px 0 12px;
}

.mini-select {
  width: 170px;
  height: 32px;
  border: 1px solid #b8c5d9;
  background: #fff;
  border-radius: 3px;
  color: #2d405a;
  padding: 0 10px;
}

.meta-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-top: 18px;
  margin-bottom: 18px;
}

.meta-box {
  display: flex;
  align-items: center;
  gap: 12px;
  border: 1px solid #bfd0ea;
  background: rgba(255,255,255,0.15);
  padding: 8px 10px;
}

.meta-box label {
  min-width: 90px;
  font-weight: 700;
  color: #2d405a;
}

.meta-value {
  flex: 1;
}

.action-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
  padding-top: 4px;
}

.btn {
  border: 1px solid #b9c7dc;
  background: #f5f7fb;
  color: #2d405a;
  border-radius: 3px;
  padding: 7px 14px;
  font-size: 12px;
  cursor: pointer;
}

.btn-primary {
  background: #dfeaf9;
  border-color: #aac0df;
}

@media (max-width: 1100px) {
  .club-content {
    display: block;
  }

  .club-side-panel {
    border-right: none;
    border-bottom: 1px solid #bfd0ea;
  }

  .field-row,
  .field-row.compact {
    display: block;
  }

  .field-control,
  .field-control.small {
    max-width: none;
    width: 100%;
  }

  .meta-row {
    grid-template-columns: 1fr;
  }
}
</style>



// WEBPACK FOOTER //
// ClubSetting.vue?3329aba0